import React from 'react';
import { Alert, Button } from 'antd';

type LoadErrorAlertProps = {
  message: string;
  error: Error;
  onRetry?: () => void;
};

const LoadErrorAlert = ({
  message,
  error,
  onRetry,
}: LoadErrorAlertProps): JSX.Element => (
  <Alert
    type="error"
    showIcon
    message={message}
    description={error.message}
    action={
      onRetry && (
        <Button size="small" onClick={() => onRetry()}>
          Retry
        </Button>
      )
    }
  />
);

export default LoadErrorAlert;
